import { MUITab } from "@abb/arcadia-ui-react"
import { useHashTab } from "../../../hooks/useHashTab"
import { AppRegistrations } from "./app_registrations_tab/AppRegistrations"

const APP_REGISTRATIONS_TAB_ID = "app-registrations"

export function AppRegistrationsContainer() {
  const { activeTab, handleTabChange } = useHashTab(APP_REGISTRATIONS_TAB_ID)

  return (
    <div>
      <MUITab
        tabItems={[{ id: APP_REGISTRATIONS_TAB_ID, label: "App Registrations" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === APP_REGISTRATIONS_TAB_ID && <AppRegistrations />}
    </div>
  )
}
